export default {
    /**
     * Get 各種リスト情報取得
     */
    loadListObj (obj) {
        let url = obj.url
        let data = obj.data
        if (obj.data) {
            return axios.get(route(url, data))
        } else {
            return axios.get(route(url))
        }
    },

    /**
     * Get 各種リスト情報取得(see more)
     */
    loadListObjSeeMore (data) {
        return axios.get(data)
    },

    /**
     * Get ポイント
     */
    loadPoint () {
        return axios.get(route('invite.point'))
    },

    /**
     * Post 招待情報取得
     */
    loadInviteInfo (data) {
        return axios.post(route('invite.code'), data)
    },

    /**
     * get 法人リスト取得
     */
    loadCompanys () {
        return axios.get(route('invite.companys'))
    },

    /**
     * Post 法人削除
     */
    delCompany (data) {
        return axios.post(route('invite.company.del'), data)
    },

    /**
     * Post 法人追加
     */
    addCompany (data) {
        return axios.post(route('invite.company.add'), data)
    },

    /**
     * Post 法人修正
     */
    saveCompanyInfo (data) {
        return axios.post(route('invite.company.save'), data)
    },


    /**
     * Post　メールで招待コードをシェアする
     */
    shareInviteCode (data) {
        return axios.post(route('invite.code.share'), data)
    },

    /**
     * get 法人詳細（登録済み一覧）取得
     */
    loadCompanyDetail (data) {
        return axios.get(route('invite.company.detail', data))
    },

    /**
     * Post 法人詳細設定
     */
    companyInviteDetailChange (data) {
        return axios.post(route('invite.company.detail.set'), data)
    },

    /**
     * get 個人レベルリスト取得
     */
    loadTechLevel () {
        return axios.get(route('invite.tech.level'))
    },

    /**
     * Get 招待済み友達取得
     */
    loadTechChild (data) {
        return axios.get(route('invite.tech.child', data))
    },

    /**
     * get 履歴書リスト取得
     */
    loadTechResume () {
        return axios.get(route('invite.tech.resume'))
    },

    /**
     * post 履歴書配信Flg設定
     */
    changeTechResumeMailFlg (data) {
        return axios.post(route('invite.tech.resume.mail.flg'), data)
    },

    /**
     * post 受信日最新化
     */
    updateTechResumeRecentInDay (data) {
        return axios.post(route('invite.tech.resume.recent.in.day'), data)
    },

    /**
     * post 履歴書削除
     */
    deleteTechResume (data) {
        return axios.post(route('invite.tech.resume.del'), data)
    },

    /**
     * Post 履歴書情報登録/更新
     */
    saveResumeInfo (data) {
        return axios.post(route('invite.tech.resume.save'), data)
    },

    /**
     * Get 履歴書情報取得
     */
    loadResumeInfo (data) {
        return axios.get(route('invite.tech.resume.detail', data.id))
    },

    /**
     * 最新のポイント情報取得
     */
    loadLatestPointInfo () {
        return axios.get(route('invite.point.latest'))
    },

    /**
     * 今月のポイント発行
     */
    makePoint (data) {
        return axios.post(route('invite.point.create'), data)
    },

    /**
     * 個人画面初期
     */
    loadPersonInfo (data) {
        return axios.get(route('invite.tech.detail', data))
    },

    /**
     * 本人確認承認
     */
    identityOk (data) {
        return axios.post(route('invite.tech.detail.identity.ok'), data)
    },

    /**
     * 本人確認不備
     */
    identityNg (data) {
        return axios.post(route('invite.tech.detail.identity.ng'), data)
    },

    /**
     * 振込状態
     */
    payStatus (data) {
        return axios.post(route('invite.point.exchange.pay.status'), data)
    }
}
